import { render, staticRenderFns } from "./ProductForecastTables.vue?vue&type=template&id=04eb2011&"
import script from "./ProductForecastTables.vue?vue&type=script&lang=js&"
export * from "./ProductForecastTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports